import React, { useContext, useState } from 'react';
import { Card, Table, NavDropdown } from 'react-bootstrap';
import { useWidgetContext } from '../context/DragContext';
import { AuthContext } from '../context/AuthContext';
import Skeleton from 'react-loading-skeleton';

function BidAsk() {
    
    const [showDropdown, setShowDropdown] = useState(false);
    const { removeWidgetFromGrid } = useWidgetContext();
    const { bidAskData, bidLoading, apiProvider } = useContext(AuthContext);

    // console.log(apiProvider);
    
      
    const handleToggle = (isOpen) => {
        setShowDropdown(isOpen);
    };

    const handleSvgClick = () => {
        setShowDropdown(!showDropdown);
    };

    const calculateBestBidAsk = (data) => {
        let bestBid = { price: 0, size: 0 };
        let bestAsk = { price: Infinity, size: 0 };
    
        data.forEach((row) => {
            if (row.bid_px > bestBid.price) {
                bestBid = { price: row.bid_px, size: row.bid_sz };
            }
            if (row.ask_px < bestAsk.price) {
                bestAsk = { price: row.ask_px, size: row.ask_sz };
            }
        });
    
        return {
            bestBid,
            bestAsk,
        };
    };
    
    const formatPrice = (price) => (price / 1e9).toFixed(2);
    let bestBid, bestAsk;
    if (bidAskData && Array.isArray(bidAskData)) {
        const { bestBid: calculatedBestBid, bestAsk: calculatedBestAsk } = calculateBestBidAsk(bidAskData);
        bestBid = calculatedBestBid;
        bestAsk = calculatedBestAsk;
    }else {
        // Default values in case bidAskData is not available
        bestBid = { price: 0, size: 0 };
        bestAsk = { price: 0, size: 0 };
    }
    
    return (
        <Card className="main-card mt-3">
            <Card.Header className="pb-0">
                <div className="d-flex justify-content-between mt-1">
                    <h2 className="medium-heading mb-0">Bids & Asks</h2>
                    <div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            onClick={window.location.pathname !== '/demo' ? handleSvgClick : undefined}
                            style={{ cursor: window.location.pathname !== '/demo' ? 'pointer' : 'default' }}
                            >
                            <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
                            <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
                            <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
                        </svg>
                        <NavDropdown
                            show={showDropdown}
                            onToggle={handleToggle}
                            title=""
                            id="nav-dropdown"
                            align="end"
                            className="d-inline custom-nav-dropdown"
                            style={{ display: showDropdown ? 'block' : 'none' }}
                            >
                            <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('bidask')}>Close Window</NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
            </Card.Header>
            <Card.Body className="pt-0 pr-2 pl-2">
                <div className="row p-2">
                    <div className="col-6">
                        <span className="gray-text">Best Bid</span> <br />
                        {bidLoading ? (
                            <Skeleton
                                count={1}
                                style={{ margin: '4px 2px', borderRadius: '3px', width: "100px" }}
                                baseColor="rgba(137, 136, 137, 0.3)"
                                highlightColor="rgba(176, 176, 176, 0.3)"
                            />
                        ) :(
                            <span className="text-success bold">
                                {apiProvider === 'IBKR' ? `${formatPrice(bestBid?.price)} x ${bestBid?.size}` : `${bestBid?.price} x ${bestBid?.size}`}
                            </span>

                        )}
                        </div>
                    <div className="col-6 text-end">
                        <span className="gray-text">Best Ask</span> <br />
                        {bidLoading ? (
                            <Skeleton
                                count={1}
                                style={{ margin: '4px 2px', borderRadius: '3px', width: "100px" }}
                                baseColor="rgba(137, 136, 137, 0.3)"
                                highlightColor="rgba(176, 176, 176, 0.3)"
                            />
                        ) :(
                            <span className="text-danger bold">
                                {apiProvider === 'IBKR' ? `${formatPrice(bestAsk?.price)} x ${bestAsk?.size}` : `${bestAsk?.price} x ${bestAsk?.size}`}
                            </span>
                        )}
                    </div>
                </div>
                <div className="table-responsive scrollbar-custom m-h-170">
                    <Table hover className="transaction-table">
                        <thead>
                            <tr>
                                <th>Size</th>
                                <th>Bid</th>
                                <th className="text-end">Ask</th>
                                <th className="text-end">Size</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bidLoading ? (
                                <tr>
                                    <td colSpan={4}>
                                    <Skeleton
                                        count={3}
                                        style={{ margin: '4px 2px', borderRadius: '3px' }}
                                        baseColor="rgba(137, 136, 137, 0.3)"
                                        highlightColor="rgba(176, 176, 176, 0.3)"
                                    />
                                    </td>
                                </tr>
                            ) :
                            bidAskData && bidAskData.length > 0 ? (
                                bidAskData.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.bid_sz}</td>

                                        <td className="text-success">{apiProvider === 'IBKR' ? formatPrice(row.bid_px) : row.bid_px}</td>
                                        <td className="text-danger text-end">{apiProvider === 'IBKR' ? formatPrice(row.ask_px): row.bid_px}</td>
                                        <td className="text-end">{row.ask_sz}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
}

export default BidAsk;